<template>
  <popup :opened="dataToShow" @close="close">
    <!-- BEGIN Content modal add competence -->
    <div v-if="dataToShow">
      <div class="my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15">
        <h3 class="mb-10">Langue</h3>
        <div class="flex justify-center">
          <input-text
            :error="true"
            :value="newLangue.name"
            class="lg:w-1/2"
            libelle="Langue"
            name="langueName"
            @input="
              (newValue) => {
                newLangue.name = newValue;
              }
            "
          />
        </div>
        <div class="text-center my-5">
          <p v-if="false" class="text-sm">
            {{ descriptionNiveaux[niveaux[newLangue.niveau]] }}
          </p>
        </div>
        <div class="my-5 flex justify-center">
          <input-range
            class="lg:w-1/2"
            :range-values="niveaux"
            size-libelle="text-sm"
            name="niveauLangue"
            :value="parseInt(newLangue.niveau)"
            @input="
              (newValue) => {
                newLangue.niveau = newValue;
              }
            "
          />
        </div>
        <div class="flex justify-center">
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="ENREGISTRER"
            typeShadow="shadow-pink"
            @clickAction="langueToEdit ? modifyLangue() : addLangue()"
          />
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from '../../../components/Popup.vue';
import Icon from '../../../components/Icon.vue';
import InputText from '../../../components/Inputs/InputText.vue';
import InputSelect from '../../../components/Inputs/InputSelect.vue';
import DatePicker from '../../../components/Inputs/DatePicker.vue';
import ActionButton from '../../../components/ActionButton.vue';
import InputRange from '../../../components/Inputs/InputRange.vue';

export default {
  components: {
    Popup,
    Icon,
    InputText,
    InputSelect,
    DatePicker,
    ActionButton,
    InputRange,
  },

  props: {
    dataToShow: {
      type: Boolean,
      required: false,
      default: false,
    },
    langueToEdit: {
      type: Object,
      required: false,
      default: null,
    },
    niveaux: {
      type: Array,
      required: false,
      default: ['Débutant', 'Intermédiaire', 'Courant', 'Avancé', 'Bilingue'],
    },
  },

  data() {
    return {
      newLangue: {
        name: '',
        niveau: 0,
      },
    };
  },

  methods: {
    close() {
      this.$emit('close');
    },

    addLangue() {
      this.$emit('addLangue', this.newLangue);
      this.close(false);
      this.newLangue = {
        name: '',
        niveau: 0,
      };
    },

    modifyLangue() {
      this.$emit('modifyLangue', this.newLangue);
      this.close(false);
      this.newLangue = {
        name: '',
        niveau: 0,
      };
    },
  },

  computed: {
    descriptionNiveaux() {
      return {
        A1: 'Communication simple sur des sujets familiers',
        A2: 'Communication et échanges simples sur des sujets familiers et habituels',
        B1: "Capacité à s'exprimer dans une situation authentique; description d'une expérience, d'un évènement",
        B2: 'Communication et argumentation aisées sur des sujets généraux concrets ou abstraits',
        C1: 'Expression spontanée sur tous les sujets de façon claire et structurée',
        C2: 'Expression parfaitement correcte et précise sur tous les sujets',
      };
    },
  },

  watch: {
    dataToShow: {
      handler() {
        if (this.langueToEdit) {
          this.newLangue = this.langueToEdit.value;
          return;
        }
        this.newLangue = {
          name: '',
          niveau: 0,
        };
      },
    },
  },
};
</script>
